export default function() {

  const anchors = document.querySelectorAll('a[href^="#"]');

  if(anchors) {
    anchors.forEach((anchor)=> {
      anchor.addEventListener('click', (e)=> {
        e.preventDefault();
        const thisHash = anchor.getAttribute('href');
        if( thisHash !== '#' && thisHash !== '#newsletter') {
          scrollToAnchor(thisHash)
        }
      });
    });
  }

  if(window.location.hash) {
    scrollToAnchor(window.location.hash)
  }

  function scrollToAnchor(anchor) {
    window.lenis.scrollTo(anchor, {
      offset: -60
    })
  }
}